import { useNovel } from '@/context/novel-context';
import { EntitySummary } from '@/lib/types';
import { useMemo } from 'react';
import { toTimestamp } from '@/lib/date-utils';

/**
 * Hook to fetch all organizations for a novel from summaries.
 */
export function useOrganizations(): {
  organizations: EntitySummary[];
  isLoading: boolean;
  error: Error | null;
} {
  const { novel, isLoading, error } = useNovel();

  const organizations = useMemo(() => {
    const summaryMap = novel.summaries.organizations;
    return Object.values(summaryMap)
      .sort((a, b) => {
        const dateA = toTimestamp(a.updatedAt);
        const dateB = toTimestamp(b.updatedAt);
        return dateB - dateA;
      });
  }, [novel]);

  return {
    organizations,
    isLoading,
    error: error as Error | null,
  };
}
